module.exports = __webpack_public_path__ + "img/企业介绍_使命.3c63a378.png";